import React, { useState, useEffect } from 'react'

import { TextInput, ToggleSwitch, Select, Field, FieldLabel, ValidationMessage } from '../../../../../../index'

export const ImageEditForm = ({ attributes, updateFormData, hasError, children }) => {
  const [formData, setFormData] = useState({
    alt: attributes.alt || '',
    position: attributes.position || 'none',
    caption: attributes.caption?.trim() || '',
    anchorLink: attributes.anchorLink?.trim() || '',
    inline: attributes.inline || false,
    target: attributes.target || false
  })
  const [alignmentValue, setAlignmentValue] = useState(() => {
    const position = formData.position || 'none';
    const label = position.charAt(0).toUpperCase() + position.slice(1);
    return {
      id: position,
      value: position,
      label: label
    };
  });
  const [errorMessage, setErrorMessages] = useState({
    anchorLink: ''
  })

  useEffect(() => {
    updateFormData(formData)
  }, [formData])

  useEffect(() => {
    let errorExist = false
    Object.values(errorMessage).some((message) => {
      return (errorExist = Boolean(message))
    })
    if (hasError.value !== errorExist) hasError.callback(errorExist)
  }, [errorMessage])

  const handleChange = (e) => {
    e.persist()
    const targetName = e.target.name
    const targetValue = e.target.value

    setFormData((prevState) => {
      return { ...prevState, [targetName]: targetValue }
    })
  }

  const handleToggle = (e) => {
    e.persist()
    const targetName = e.target.name
    const targetValue = e.target.checked
    setFormData((prevState) => {
      if (targetName === 'inline' && targetValue && (prevState.position === 'center' || !prevState.position)) {
        setAlignmentValue({
          id: 'left',
          value: 'left',
          label: 'Left'
        })
        return {
          ...prevState,
          inline: targetValue,
          position: 'left'
        }
      }
      return { ...prevState, [targetName]: targetValue }
    })
  }

  return (
    <div className='FormFields' style={{ padding: '0px 2px', width: '100%' }}>
      <Field>
        <FieldLabel version='v2' htmlFor='alt'>Alt Text</FieldLabel>
        <TextInput version="v2" value={formData.alt} name="alt" onChange={handleChange}></TextInput>
      </Field>

      <Field>
        <FieldLabel version='v2' htmlFor='position'>Alignment</FieldLabel>
        <Select
          version='v2'
          onChange={(data) => {
            setFormData((prevState) => {
              return {
                ...prevState,
                position: data.value
              }
            })

            setAlignmentValue(data)
          }}
          name="position"
          value={alignmentValue}
          placeholder="Alignment"
          options={
            formData.inline
              ? [
                {
                  id: 'none',
                  value: 'none',
                  label: 'None'
                },
                {
                  id: 'left',
                  value: 'left',
                  label: 'Left'
                },
                {
                  id: 'right',
                  value: 'right',
                  label: 'Right'
                }
              ]
              : [
                {
                  id: 'none',
                  value: 'none',
                  label: 'None'
                },
                {
                  id: 'left',
                  value: 'left',
                  label: 'Left'
                },
                {
                  id: 'center',
                  value: 'center',
                  label: 'Center'
                },
                {
                  id: 'right',
                  value: 'right',
                  label: 'Right'
                }
              ]
          }
          testId={"scrte-image-align"}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          menuPortalTarget={document.body}
          optionClassname='image-alignment-option'
        ></Select>
      </Field>

      <Field>
        <FieldLabel version='v2' htmlFor='caption'>Caption</FieldLabel>
        <TextInput
          version="v2"
          value={formData.caption}
          type="text"
          placeholder="Enter a caption"
          name="caption"
          onChange={handleChange}
        />
      </Field>

      <Field>
        <FieldLabel version='v2' htmlFor='anchorLink'>Embed Link</FieldLabel>
        <TextInput
          version="v2"
          value={formData.anchorLink}
          type="url"
          placeholder="Enter a link"
          name="anchorLink"
          onChange={handleChange}
          error={!!errorMessage.anchorLink}
        />
        {
          errorMessage.anchorLink &&
          <ValidationMessage
            version='v2'
            style={{ marginLeft: '10px', marginTop: '5px' }}
          >
            {errorMessage.anchorLink}
          </ValidationMessage>
        }
      </Field>
      {children}
      <div className='ToggleWrap'>
        <ToggleSwitch
          label="Open link in a new tab"
          name='target'
          checked={formData.target}
          onChange={handleToggle}
          testId={'scrte-image-new-tab'}
        />
      </div>
      <div className='ToggleWrap'>
        <ToggleSwitch
          label="Inline image"
          name='inline'
          checked={formData.inline}
          onChange={handleToggle}
          testId={'scrte-image-inline'}
        />
      </div>
    </div>
  )
}
